import { render } from "./LmForm.vue?vue&type=template&id=04e9f07c"
import script from "./LmForm.vue?vue&type=script&setup=true&lang=js"
export * from "./LmForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/learning_module/components/lm/LmForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04e9f07c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04e9f07c', __exports__)) {
    api.reload('04e9f07c', __exports__)
  }
  
  module.hot.accept("./LmForm.vue?vue&type=template&id=04e9f07c", () => {
    api.rerender('04e9f07c', render)
  })

}


export default __exports__